// Vuex user module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  supervisorsBelongsToUser: [],
};

const getters = {
  supervisorsBelongsToUser: state => state.supervisorsBelongsToUser,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
